/** localStorage helpers for Consultant page preferences; storage failures fall back silently. */

export const readStoredJson = <T>( key: string, fallback: T ): T => {
    try {
        const raw = window.localStorage.getItem( key );
        return raw ? JSON.parse( raw ) as T : fallback;
    } catch {
        return fallback;
    }
};

export const writeStoredJson = ( key: string, value: unknown ): void => {
    try {
        window.localStorage.setItem( key, JSON.stringify( value ) );
    } catch {
        // ignore storage errors
    }
};

export const readStoredString = ( key: string, fallback: string ): string => {
    try {
        return window.localStorage.getItem( key ) ?? fallback;
    } catch {
        return fallback;
    }
};

export const writeStoredString = ( key: string, value: string ): void => {
    try {
        window.localStorage.setItem( key, value );
    } catch {
        // ignore storage errors
    }
};
